module.exports = __webpack_public_path__ + "static/media/personal-safe-orange.f7cbb3f7.png";